
<template>
    <div v-if="!!warranty" class="font-italic mb-2">
        <p class="mb-2" v-if="warranty.warranty_period_days > 0">Warranty: {{ warranty.warranty_period_days }} days from
            purchase</p>
        <p class="mb-2" v-else>Warranty: No Warranty</p>
        <p v-if="!!warranty.warranty_link">Warranty Information: <a :href="warranty.warranty_link" target="_blank">{{
            warranty.warranty_link }}</a></p>
    </div>
</template>

<script>

export default {
    props: {
        warranty: Object,
    },
}
</script>
